import { Directive, input } from '@angular/core';
import { type AbstractControl, NG_VALIDATORS, type ValidationErrors, type Validator } from '@angular/forms';

@Directive({
  selector: 'textarea[appMaxLength]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxLengthDirective,
      multi: true
    }
  ],
  host: {
    '(beforeinput)': 'onBeforeInput($event)'
  }
})
export class MaxLengthDirective implements Validator {
  readonly appMaxLength = input.required<number>();

  protected onBeforeInput(event: InputEvent): void {
    const isLineBreak = event.inputType === 'insertLineBreak' || event.inputType === 'insertParagraph';
    if (!event.data && !isLineBreak) {
      return;
    }

    const insertText = event.data ?? '\n';
    const textarea = event.target as HTMLTextAreaElement;
    const currentLength = textarea.value.length;
    const selectedLength = textarea.selectionEnd - textarea.selectionStart;
    const resultLength = currentLength - selectedLength + insertText.length;

    if (resultLength <= this.appMaxLength()) {
      return;
    }

    event.preventDefault();

    const remaining = this.appMaxLength() - currentLength + selectedLength;
    if (remaining <= 0) {
      return;
    }

    const truncated = insertText.slice(0, remaining);
    if (truncated) {
      textarea.setRangeText(truncated, textarea.selectionStart, textarea.selectionEnd, 'end');
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  public validate(control: AbstractControl): ValidationErrors | null {
    const length = (control.value ?? '').length;
    return length > this.appMaxLength()
      ? { maxlength: { requiredLength: this.appMaxLength(), actualLength: length } }
      : null;
  }
}
